const WORKOUT_EXERCISES_ACTION = {
  ADD_SET: 'WORKOUT_EXERCISES_ADD_SET',
  LINK_EXERCISE: 'WORKOUT_EXERCISES_LINK_EXERCISE',
  CREATE: 'WORKOUT_EXERCISES_CREATE',
  UPDATE_CURRENT: 'WORKOUT_EXERCISES_UPDATE_CURRENT',
  SAVE: 'WORKOUT_EXERCISES_SAVE',
  UPDATE_EXERCISE: 'WORKOUT_EXERCISES_UPDATE_EXERCISE',
  UPDATE_SET_DATA_FROM_EXERCISE_LOG_SUMMARY: 'WORKOUT_EXERCISES_UPDATE_SET_DATA_FROM_EXERCISE_LOG_SUMMARY',
  DELETE_LAST_CIRCUIT_EXERCISE_REST: 'WORKOUT_EXERCISES_DELETE_LAST_CIRCUIT_EXERCISE_REST',
  DELETE_LAST_WORKOUT_EXERCISE_REST: 'WORKOUT_EXERCISES_DELETE_LAST_WORKOUT_EXERCISE_REST',
  UPDATE_NOTE: 'WORKOUT_EXERCISES_UPDATE_NOTE',
  UPDATE_SET_DATA_FROM_PROFILE: 'WORKOUT_EXERCISES_UPDATE_SET_DATA_FROM_PROFILE',
  UPDATE_WEIGHT_EQUIPMENT: 'WORKOUT_EXERCISES_UPDATE_WEIGHT_EQUIPMENT',
  UPDATE_SET_DATA: 'WORKOUT_EXERCISES_UPDATE_SET_DATA',
  UPDATE_CURRENT_SET_INDEX: 'WORKOUT_EXERCISES_UPDATE_CURRENT_SET_INDEX',
  RESET_CURRENT_SET_INDEX: 'WORKOUT_EXERCISES_RESET_CURRENT_SET_INDEX',
  DELETE_CURRENT: 'WORKOUT_EXERCISES_DELETE_CURRENT',
  UPDATE_SET: 'WORKOUT_EXERCISES_UPDATE_SET',
  UPDATE_ORDER: 'WORKOUT_EXERCISES_UPDATE_ORDER',
  DELETE_SET: 'WORKOUT_EXERCISES_DELETE_SET',
  DELETE: 'WORKOUT_EXERCISES_DELETE',
  UPDATE: 'WORKOUT_EXERCISES_UPDATE'
}

export default WORKOUT_EXERCISES_ACTION
